import { toast } from "react-hot-toast";
import fetchApi from "../common/fetchApi";
import api from "../routes/api";
import axios from "axios";
import swal from "sweetalert";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

function fnBrowserDetect() {
  let userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "No browser detection";
  }

  return browserName;
}

function getOS() {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}

export const userService = {
  login,
  logout,
  register,
};

async function login(email, password, props) {
  const browser = fnBrowserDetect();
  const os = getOS();
  const finger = await FingerprintJS.load();
  const newResult = await finger.get();
  const deviceId = newResult.visitorId;
  console.log(newResult.visitorId);
  const result = await axios({
    url: "https://api.db-ip.com/v2/free/self",
    method: "GET",
  });
  console.log(result);
  if (result) {
    let deviceInfo = result.data;
    deviceInfo["browser"] = browser;
    deviceInfo["os"] = os;
    deviceInfo["deviceId"] = deviceId;
    console.log(deviceInfo, "deviceInfo");
    localStorage.setItem("deviceId", deviceId);
    const requestOptions = {
      url: api.login,
      method: "POST",
      data: {
        email,
        password,
        deviceInfo,
        fcm_token: localStorage.getItem("fcm_token"),
      },
    };
    return axios(requestOptions).then((user) => {
      console.log(user);
      console.log(props, "props");
      if (user && user.data && !user.data.success && user.data.status === 201) {
        props.navigate(`/email-verification/${user.data.userId}`);
        return user;
      }
      user.data.success
        ? toast.success("Login success")
        : toast.error("Login failed");
      localStorage.setItem("user", JSON.stringify(user));
      return user;
    });
  }
}

// remove user from local storage to log user out
function logout() {
  localStorage.removeItem("user");
}

// register user request
function register(user, props) {
  console.log(props, "props");
  const requestOptions = {
    url: api.registerUser,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };
  return fetchApi(requestOptions).then((res) => {
    console.log(props, "props");
    console.log(res);
    if (res && res.data && res.data.success) {
      return props.navigate(`/email-verification/${res.data.userId}`);
    }
    if (res && res.data && !res.data.success) {
      toast.error(res.data.message);
      return swal(res.data.message);
    }
    res.success
      ? toast.success("Register successfull")
      : toast.error("Register failed");
  });
}

// function handleResponse(response) {
//   return response.then(text => {
//     const data = text && JSON.parse(text);
//     if (!response.ok) {
//       if (response.status === 400) {
//         logout();
//         // location.reload(true);
//       }
//       const error = (data && data.message) || response.statusText;
//       return Promise.reject(error);
//     }

//     return data;
//   });
// }
